const CONNECTION_FIELDS = `
  workspaceId
  provider
  connected
  connectedBy { id name { first last } }
  connectedAt
  lastValidatedAt
`;

export const GET_INTEGRATION_CONNECTIONS = `
  query GET_INTEGRATION_CONNECTIONS($workspaceId: ID!) {
    integrationAuth {
      listConnections(workspaceId: $workspaceId) { ${CONNECTION_FIELDS} }
    }
  }
`;

export const START_INTEGRATION_CONNECTION = `
  mutation START_INTEGRATION_CONNECTION(
    $workspaceId: ID!, $provider: IntegrationProvider!, $redirectUri: String!
  ) {
    integrationAuth {
      startConnection(workspaceId: $workspaceId, provider: $provider, redirectUri: $redirectUri) {
        authorizeUrl
      }
    }
  }
`;

export const COMPLETE_INTEGRATION_CONNECTION = `
  mutation COMPLETE_INTEGRATION_CONNECTION(
    $provider: IntegrationProvider!, $code: String!, $state: String!
  ) {
    integrationAuth {
      completeConnection(provider: $provider, code: $code, state: $state) { ${CONNECTION_FIELDS} }
    }
  }
`;

export const DISCONNECT_INTEGRATION = `
  mutation DISCONNECT_INTEGRATION($workspaceId: ID!, $provider: IntegrationProvider!) {
    integrationAuth {
      disconnectConnection(workspaceId: $workspaceId, provider: $provider) { ${CONNECTION_FIELDS} }
    }
  }
`;
